import caseStudies from "./caseStudies";

const work = {
  hero: {
    eyebrow: "Case studies",
    title: "What this work looks like when it lands.",
    intro:
      "Some of these are public proof points — real outcomes from real teams I've drawn on while building this practice. As real engagements close, I'll replace them with my own work. Every story below is labelled so you know which is which.",
  },
  cases: caseStudies,
};

export default work;
